import { render, staticRenderFns } from "./TableInspectDivision.vue?vue&type=template&id=4c15033f&scoped=true"
import script from "./TableInspectDivision.vue?vue&type=script&lang=js"
export * from "./TableInspectDivision.vue?vue&type=script&lang=js"
import style0 from "./TableInspectDivision.vue?vue&type=style&index=0&id=4c15033f&prod&scoped=true&lang=scss"
import style1 from "./TableInspectDivision.vue?vue&type=style&index=1&id=4c15033f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15033f",
  null
  
)

export default component.exports